import { GridColDef } from '@mui/x-data-grid';
import { Link } from '@mui/material';
import { DataGridLink } from '@carcareers/components';

import { routes } from '@carcareers/utils';

export const ROOFTOP_INDEX_COLUMNS: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70 },
  {
    field: 'name',
    headerName: 'Name',
    width: 200,
    renderCell: (params) => (
      <DataGridLink
        link={`/${routes.EMPLOYER_HOME}/${routes.EMPLOYER_ROOFTOPS_VIEW.replace(':id', params.row.id.toString())}`}
        content={params.row.name}
      />
    ),
  },
  {
    field: 'owner',
    headerName: 'Owner',
    width: 200,
    valueGetter: (_, row) => row.owner.user.firstName + ' ' + row.owner.user.lastName,
  },
  {
    field: 'location',
    headerName: 'Location',
    width: 200,
  },
  {
    field: 'authorizations',
    headerName: 'Authorized Employers',
    width: 200,
    valueGetter: (_, row) => row.authorizations?.length || 0,
  },
  {
    field: 'jobs',
    headerName: 'Jobs',
    width: 100,
    renderCell: (params) => (
      <DataGridLink
        link={`/${routes.EMPLOYER_HOME}/${routes.EMPLOYER_ROOFTOPS_VIEW.replace(':id', params.row.id.toString())}`}
        content={params.row.jobs?.length || 0}
      />
    ),
  },
  {
    field: 'phone',
    headerName: 'Phone',
    width: 150,
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 200,
  },
  {
    field: 'website',
    headerName: 'Website',
    width: 200,
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 300,
  },
  {
    field: 'updatedAt',
    headerName: 'Updated',
    width: 150,
    valueGetter: (_, row) =>
      new Date(row.updatedAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
];

export const ROOFTOP_AUTHORIZED_REQUEST_INDEX_COLUMNS: GridColDef[] = [
  {
    field: 'email',
    headerName: 'Email',
    flex: 2,
    valueGetter: (_, row) => row.employer?.user?.email || row.email || 'Unknown',
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    valueGetter: (_, row) => row.status,
  },
  {
    field: 'createdAt',
    headerName: 'Request Date',
    flex: 1,
    valueGetter: (_, row) => new Date(row.createdAt).toLocaleDateString(),
  },
];

export const ROOFTOP_INDEX_COLUMN_INITIAL_STATE = {
  id: true,
  name: true,
  employer: true,
  location: true,
  phone: false,
  email: true,
  website: false,
  description: false,
  createdAt: true,
  updatedAt: false,
  authorizations: false,
  jobs: false,
};

export const ROOFTOP_AUTHORIZED_REQUEST_INDEX_COLUMN_INITIAL_STATE = {
  id: false,
  employer: true,
  email: true,
  status: true,
  createdAt: true,
};

export const ROOFTOP_ADMIN_INDEX_COLUMNS: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'name',
    headerName: 'Rooftop Name',
    width: 150,
    renderCell: (params) => (
      <DataGridLink
        link={`/${routes.ADMIN_HOME}/${routes.ADMIN_ROOFTOPS_VIEW.replace(':id', params.row.id.toString())}`}
        content={params.row.name}
      />
    ),
  },
  {
    field: 'location',
    headerName: 'Location',
    width: 200,
  },
  {
    field: 'owner',
    headerName: 'Owner',
    width: 150,
    renderCell: (params) => {
      const name = `${params.row.owner?.user?.firstName || ''} ${params.row.owner?.user?.lastName || ''}`.trim();
      return (
        <DataGridLink
          link={`/${routes.ADMIN_HOME}/${routes.ADMIN_EMPLOYERS_VIEW.replace(
            ':id',
            params.row.owner?.id?.toString() || '0',
          )}`}
          content={name || 'No Owner'}
        />
      );
    },
  },
  {
    field: 'email',
    headerName: 'Contact Email',
    width: 200,
  },
  {
    field: 'phone',
    headerName: 'Phone',
    width: 150,
  },
  {
    field: 'activeJobs',
    headerName: 'Active Jobs',
    width: 150,
    valueGetter: (_, row) => row.activeJobs || 0,
  },
  {
    field: 'totalApplications',
    headerName: 'Applies',
    width: 150,
    valueGetter: (_, row) => row.totalApplications || 0,
  },
  {
    field: 'createdAt',
    headerName: 'Created',
    width: 120,
    valueGetter: (_, row) =>
      new Date(row.createdAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
  {
    field: 'updatedAt',
    headerName: 'Updated',
    width: 120,
    valueGetter: (_, row) =>
      new Date(row.updatedAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
];

export const ROOFTOP_ADMIN_INDEX_COLUMN_INITIAL_STATE = {
  id: true,
  name: true,
  location: true,
  owner: true,
  email: true,
  phone: false,
  activeJobs: true,
  totalApplications: true,
  createdAt: false,
  updatedAt: false,
};

export const ROOFTOP_ADMIN_INDEX_COLUMNS_INITIAL_STATE_MOBILE = {
  id: false,
  name: true,
  location: true,
  owner: false,
  email: false,
  phone: false,
  activeJobs: true,
  totalApplications: false,
  createdAt: false,
  updatedAt: false,
};
